import * as React from 'react';
const KEY = 'rocket-theme';
function read() {
    try {
        const saved = localStorage.getItem(KEY);
        return saved === 'dark' || saved === 'system' ? saved : 'light';
    }
    catch {
        return 'light';
    }
}
function apply(theme) {
    const dark = theme === 'dark' || (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
    document.documentElement.classList.toggle('dark', dark);
}
/** Tema claro (padrão), escuro ou do sistema, salvo neste navegador. */
export function useTheme() {
    const [theme, setThemeState] = React.useState(read);
    // Mantém em sincronia todos os lugares que usam o tema (menu, cabeçalho, avisos).
    React.useEffect(() => {
        const onSync = (event) => setThemeState(event.detail);
        window.addEventListener('rocket-theme', onSync);
        return () => window.removeEventListener('rocket-theme', onSync);
    }, []);
    React.useEffect(() => {
        apply(theme);
        if (theme !== 'system')
            return;
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        const onChange = () => apply('system');
        media.addEventListener('change', onChange);
        return () => media.removeEventListener('change', onChange);
    }, [theme]);
    const setTheme = React.useCallback((next) => {
        try {
            localStorage.setItem(KEY, next);
        }
        catch {
            /* navegação privada: aplica só nesta sessão */
        }
        setThemeState(next);
        window.dispatchEvent(new CustomEvent('rocket-theme', { detail: next }));
    }, []);
    const resolved = theme === 'system'
        ? typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches
            ? 'dark'
            : 'light'
        : theme;
    return { theme, resolved, setTheme };
}
